import type {IWHIVisaDetails, SponsorDetails} from '@nib/types-session-api';
import {IWHIJoinState} from '../../store';
import _get from 'lodash/get';

export const selectData = (state: IWHIJoinState): IWHIVisaDetails => _get(state, 'session.session.visaDetails') || ({} as IWHIVisaDetails);

export const getVisaSubclass = (state: IWHIJoinState): string | null => selectData(state).visaSubclass;
// Need to get this from sponsorDetails but then fallback to this. Renamed the selector to better reflect what we are retrieving
export const getVisaSponsorDetails = (state: IWHIJoinState): SponsorDetails => selectData(state).sponsorDetails || ({} as SponsorDetails);
export const getExpectedVisaEndDate = (state: IWHIJoinState) => selectData(state).expectedVisaEndDate;
export const getPassportNumber = (state: IWHIJoinState) => selectData(state).passportNumber;
